import { createSlice } from "@reduxjs/toolkit";
import { getSalesPaymentHistoryReport, getSalesCommission } from "./thunk";
export const initialState = {
  // Get Sales Paged Payment History Report
  getSalesPaymentHistoryReportData: [],
  isGetSalesPaymentHistoryReportSuccess: false,
  getSalesPaymentHistoryReportLoading: false,
  // Get Sales Commission Report
  getSalesCommissionData: [],
  isGetSalesCommissionSuccess: false,
  getSalesCommissionLoading: false,
  // Error Handling
  error: {},
};

const PaymentSlice = createSlice({
  name: "PaymentSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Get Sales Paged Payment History Report
    builder.addCase(getSalesPaymentHistoryReport.pending, (state) => {
      state.getSalesPaymentHistoryReportLoading = true;
      state.error = false;
    });
    builder.addCase(
      getSalesPaymentHistoryReport.fulfilled,
      (state: any, action: any) => {
        state.getSalesPaymentHistoryReportData = action.payload;
        state.isGetSalesPaymentHistoryReportSuccess = true;
        state.getSalesPaymentHistoryReportLoading = false;
        state.error = false;
      }
    );
    builder.addCase(
      getSalesPaymentHistoryReport.rejected,
      (state: any, action: any) => {
        state.error = action.payload || null;
        state.getSalesPaymentHistoryReportLoading = false;
      }
    );
    // Get Sales Paged Commission
    builder.addCase(getSalesCommission.pending, (state) => {
      state.getSalesCommissionLoading = true;
      state.error = false;
    });
    builder.addCase(getSalesCommission.fulfilled, (state: any, action: any) => {
      state.getSalesCommissionData = action.payload;
      state.isGetSalesCommissionSuccess = true;
      state.getSalesCommissionLoading = false;
      state.error = false;
    });
    builder.addCase(getSalesCommission.rejected, (state: any, action: any) => {
      state.error = action.payload || null;
      state.getSalesCommissionLoading = false;
    });
  },
});

export default PaymentSlice.reducer;
